/**
 * Original-file download over the HUB-086 bytes route (`GET /documents/:id/
 * content`, typed as `documentsGetContent`). Fetched through the shared hub
 * client — NOT a plain `<a href>` to the API host — so the download rides the
 * same cookie + auto-refresh path as every other admin call: an expired access
 * cookie refreshes and replays instead of landing the user on a raw JSON 404.
 * The browser sink is injectable because the admin test env has no DOM.
 */
import { hub } from '@/lib/hub-client';

export type SaveBytes = (bytes: Uint8Array, contentType: string, filename: string) => void;

function saveInBrowser(bytes: Uint8Array, contentType: string, filename: string): void {
  const url = URL.createObjectURL(new Blob([bytes as BlobPart], { type: contentType }));
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

export async function downloadDocument(
  id: string,
  filename: string,
  save: SaveBytes = saveInBrowser,
): Promise<void> {
  const { bytes, contentType } = await hub.documentsGetContent({ params: { id } });
  save(bytes, contentType, filename);
}
